import { cleanSupplierArticles } from '@/utils/nomenclature/articles'

import type { NomenclatureCreationType } from '../SingularImport.config'

const toNumberOrZero = (value: string | undefined) =>
  value ? Number(value) : 0

export const toNomenclatureCreationRequest = (
  values: NomenclatureCreationType
) => ({
  article: values.article,
  supplierArticles: cleanSupplierArticles(values.supplierArticles ?? []),
  description: values.description,
  parentId: values.nomenclatureGroup,
  brand: values.brand.value,
  category: values.category,
  itemLength: toNumberOrZero(values.itemLength),
  itemWidth: toNumberOrZero(values.itemWidth),
  itemHeight: toNumberOrZero(values.itemHeight),
  itemWeight: toNumberOrZero(values.itemWeight),
  unitOfMeasurement: values.unitOfMeasurement?.value,
  warranty: toNumberOrZero(values.warranty),
  countryOfOrigin: values.countryOfOrigin?.value,
  barcode: values.barcode || '',
  details: values.details || '',
  comment: values.comment || '',
})

export type NomenclatureCreationRequest = ReturnType<
  typeof toNomenclatureCreationRequest
>
